<template>
  <EntityList class="docuforms-list"
              :class="{'docuforms-list--empty': !sortedGroups.length}"
              :items="sortedGroups"
              :actions="actions"
              page-getter="mattersModule/allDocuformsPage"
              completed-getter="mattersModule/allDocuformsCompleted"
              error-getter="mattersModule/allDocuformsError"
              page-setter="mattersModule/setAllDocuformsPage"
              load-action="mattersModule/loadAllDocuforms"
              reset-action="mattersModule/resetDocuforms"
              :refresh-id="refreshId"
              empty-state-svg-path="empty_doc_list.svg"
              :empty-state-title="$t('document.empty_state.title')"
              :empty-state-subtitle="$t('document.empty_state.subtitle')"
              :empty-state-cta-text="$t('document.action.share')"
              :error-text="$t('document.empty_state.load_error')"
              :error-action-text="$t('document.empty_state.load_action')"
              @action="emitAction"
              @item-click="view"
              @cta-click="onCtaClick"
              @refresh="refresh">
    <slot slot-scope="docuform">
      <DocuformListItemDesktop v-if="$vuetify.breakpoint.mdAndUp"
                               :docuform="docuform"/>
      <DocuformListItemMobile v-else
                              :docuform="docuform"/>
    </slot>
  </EntityList>
</template>

<script>
import {EntityList} from "@/modules/common/components";
import DocuformListItemDesktop from "./DocuformListItemDesktop";
import DocuformListItemMobile from "./DocuformListItemMobile";
import {docuformsService} from "@/modules/common/services";
import {FORMATS} from "@/modules/common/filters/DateFormats";
import {mapGetters} from "vuex";

export default {
  name: "DocuformsList",
  components: {EntityList, DocuformListItemDesktop, DocuformListItemMobile},
  data() {
    return {
      actions: [
        { event: "action", action: "view", title: this.$t('document.action.view') },
        { event: "action", action: "delete", title: this.$t('document.action.delete') }
      ],
      refreshId: +new Date()
    };
  },
  computed: {
    ...mapGetters('accountModule', ['staff']),
    sortedGroups() {
      let groups = [...this.docuformsGroupedByMonth];
      this.descSort(groups, 'title');
      groups.forEach(group => this.descSort(group.items, 'updated_at'));
      return groups;
    },
    docuformsGroupedByMonth() {
      const docuforms = JSON.parse(JSON.stringify(this.$store.getters['mattersModule/allDocuforms']));

      const groups = docuforms.reduce((total, docuform) => {
        const docuformGroup = this.$options.filters.dateFormatUTC(docuform.updated_at, FORMATS.MONTH_YEAR, this.staff.time_zone_name);

        if (total[docuformGroup]) {
          total[docuformGroup].total++;
          total[docuformGroup].items.push(docuform);
        } else {
          total[docuformGroup] = {
            title: docuformGroup,
            total: 1,
            items: [docuform]
          };
        }

        total[docuformGroup].summaryText = this.$t('document.action.document_counter', {number: total[docuformGroup].total});
        return total;
      }, {});

      return Object.values(groups);
    }
  },
  methods: {
    descSort(array, param) {
      return array.sort((a, b) => new Date(a[param]) > new Date(b[param]) ? -1 : 1);
    },
    emitAction(action, uid) {
      this[action](uid);
    },
    view(uid) {
      this.$frontageApi.navigateTo('app.docuform', {uid});
    },
    async delete(uid) {
      await docuformsService.deleteItem(uid);
      this.refresh();
    },
    onCtaClick() {
      this.$frontageApi.send('send-document');
    },
    refresh() {
      this.$store.dispatch({type: "mattersModule/resetDocuforms"});
      this.refreshId = +new Date();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.docuforms-list {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1), 0 2px 2px rgba(0, 0, 0, 0.06), 0 3px 1px -2px rgba(0, 0, 0, 0.06);
  background-color: $white-color-1;

  &--empty {
    overflow-y: hidden;
  }

  @include md-and-up {
    border-radius: 6px 6px 0 0;
  }

  ::v-deep .groups-container {

    @include sm-and-down {
      padding-bottom: 50px;
    }
  }

  ::v-deep .list-item {

    .right-area {

      @include sm-and-down {
        display: none;
      }
    }
  }
}
</style>
